import React from 'react';
import type { Transaction } from '../../../data/mockData';
interface TransactionMiniListProps {
  transactions: Transaction[];
}
export function TransactionMiniList({
  transactions
}: TransactionMiniListProps) {
  return <div className="mt-3 bg-gray-50 dark:bg-dark-hover rounded-xl overflow-hidden" data-id="element-141">
      <p className="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide px-3 pt-3 pb-2" data-id="element-142">
        Recent Transactions
      </p>
      <div className="divide-y divide-gray-100 dark:divide-gray-800" data-id="element-143">
        {transactions.map(tx => <div key={tx.id} className="flex items-center justify-between px-3 py-2" data-id="element-144">
            <div className="flex items-center gap-2" data-id="element-145">
              <span className="text-base" data-id="element-146">{tx.icon}</span>
              <div data-id="element-147">
                <p className="text-xs font-medium text-gray-800 dark:text-gray-200 truncate max-w-[130px]" data-id="element-148">
                  {tx.merchant}
                </p>
                <p className="text-xs text-gray-400" data-id="element-149">{tx.date}</p>
              </div>
            </div>
            <span className={`text-xs font-semibold ${tx.type === 'credit' ? 'text-accent-600 dark:text-accent-400' : 'text-gray-700 dark:text-gray-300'}`} data-id="element-150">
              {tx.type === 'credit' ? '+' : '-'}$
              {Math.abs(tx.amount).toFixed(2)}
            </span>
          </div>)}
      </div>
    </div>;
}